import React from 'react';

export default function Facebook() {

    return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule='evenodd' clipRule="evenodd" d="M5.29887 0H18.7011C21.6276 0 24 2.37239 24 5.29887V18.7011C24 21.6276 21.6276 24 18.7011 24L15.1798 24V15.9228H18.1033L18.6979 12.2066H15.1798V9.45812C15.1798 8.56777 15.9014 7.84609 16.7918 7.84609L16.7912 7.84663L18.6974 7.89627V4.42774L15.8731 4.32845C13.2186 4.32845 11.0669 6.48014 11.0669 9.13465V12.2066H7.79645V15.9228H11.0669V24L5.29887 24C2.37239 24 0 21.6276 0 18.7011V5.29887C0 2.37239 2.37239 0 5.29887 0Z" fill="#1877F2"/>
    </svg>);

}